<template>
  <div>
    <div>订单管理</div>
    <div class="mt50">
      <el-tabs v-model="tab" @tab-click="getOrderList">
        <el-tab-pane label="所有订单" name="0"></el-tab-pane>
        <el-tab-pane label="待审核" name="1"></el-tab-pane>
        <el-tab-pane label="待发货" name="2"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->
      <el-input
          v-model="search.order_no"
          clearable
          @clear="getOrderList"
          style="width: 336px"
          size="small"
          placeholder="请输入商品名称或订单号"
      ></el-input>

      <el-button @click="getOrderList" size="small" class="ml20" type="primary">搜索</el-button>
    </div>

    <!--        订单列表-->
    <!--        表头-->
    <table class="order-table" v-loading="loading">
      <thead>
      <tr class="tr-th">
        <th>产品信息</th>
        <th>产品规格</th>
        <th>设备信息</th>
        <th>配套工艺</th>
        <th>产品价格</th>
        <th>数量</th>
        <th>小计</th>
        <th>操作</th>
      </tr>
      </thead>

      <tbody v-for="item in order_list" :key="item.order_id" :id="`td-${item.order_no}`">
      <tr class="sep-row">
        <td colspan="8"></td>
      </tr>
      <tr class="tr-th">
        <td colspan="8">
          <div class="fr ac jsb">
            <div>
              <span>{{ item.create_time }}</span>
              <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
              <span class="ml20 red">{{ showCompanyType(item) }}</span>
              <span class="ml40" v-html="order_state_decide(item)"></span>
              <span class="ml40">{{ item.company_name }}</span>
            </div>
            <div class="fr ac">
              <pay-state :pay-price="item.pay_price" :order-actual-price="item.order_actual_price"/>
              <send-state :state="item.send_state" class="ml10 mr10"/>
              <assignment-status :goods-list="item.orderGoodsBeans" :shop-id="item.shop_id"/>
            </div>
          </div>
        </td>
      </tr>
      <tr class="tr-bd" v-for="(goods,k) in item.orderGoodsBeans" :key="goods.order_goods_id">
        <td>
          <div class="good-item">
            <img class="good-img" :src="goods.goods_img" alt/>
            <div>
              <a :href="`/home/detail?id=${goods.goods_id}`">{{ goods.goods_name }} {{ goods.goods_standard_name }}</a>
              <!--              <table-column :info="goods"/>-->
            </div>
          </div>
        </td>
        <td>
          <div style="width: 90px">
            <span>{{ specNameInit(goods) }}</span>
          </div>
        </td>
        <td>
          <div style="width: 110px">
            <span>{{ goods.device_id ? goods.device_id : '-' }}</span>
          </div>
        </td>
        <td>
          <p class="cursor blue" style="width: 88px">{{ goods.goods_craft_price }} </p>
        </td>
        <td>
          <p style="width: 88px">{{ goods.goods_price }} </p>
        </td>
        <td>
          <p style="width: 88px">{{ goods.goods_num }} </p>
        </td>
        <td>
          <p style="width: 88px">{{ goods.goods_actual_price }} </p>
        </td>
        <td :rowspan="item.orderGoodsBeans.length" v-if="k === 0">
          <div class="fc btn-item">

            <el-button size="mini" type="text" @click="go(`/salesOrder/confirm?order_id=${item.order_id}`)"
                       v-if="checkConfirmOrder(item)">审核订单
            </el-button>
            <i/>
            <el-button size="mini" type="text" @click="rejectOrder(item)" v-if="item.platform_sale_check_state==0">驳回订单
            </el-button>
            <i/>
            <el-button size="mini" v-if="checkGuaranteeSend(item)" type="text" @click="guaranteeSend(item.order_id)">
              担保发货
            </el-button>
            <i/>
            <el-button size="mini" type="text" v-if="item.platform_sale_check_state == 1"
                       @click="go(`/salesOrder/confirm?order_id=${item.order_id}`)">订单详情
            </el-button>
          </div>
        </td>
      </tr>
      <tr class="tr-bd">
        <td colspan="8">
          <p class="order-price">
            订单金额：
            <span style="color: #458EF6">￥{{ item.order_actual_price }}</span>
          </p>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="fr jc ac mt30 mb30">
      <el-pagination
          :hide-on-single-page="true"
          background
          :current-page.sync="page"
          layout="prev, pager, next"
          @current-change="getOrderList"
          :total="total"
      ></el-pagination>
    </div>
    <reject-order v-model="rejectShow" :order_id="order_id" :current-message="currentMessage" @success="getOrderList"/>
  </div>
</template>

<script>
import rejectOrder from "./component/rejectOrder";
import sendState from "./component/sendState.vue";
import payState from "./component/payState.vue";
import assignmentStatus from "./component/assignmentStatus.vue";

export default {
  data() {
    return {
      tab: "",
      loading: false,
      rejectShow: false,
      order_list: [],
      dictList: [],
      page: 1,
      total: 0,
      company_id: "",
      order_id: "",
      currentMessage: "",
      search: {
        order_no: ""
      }
    };
  },
  watch: {
    $route(n) {
      let param = this.$route.query;

      if (param.order_state) {
        this.tab = param.order_state;
      }
      this.page = 1;
      this.getOrderList();
    }
  },
  mounted() {
    this.getDictDataList();
    let param = this.$route.query;

    if (param.order_state) {
      this.tab = param.order_state;
    }
    this.getOrderList();
  },
  methods: {
    checkGuaranteeSend(item) {
      let {platform_sale_check_state, contract_check_state, send_state, pay_state} = item;
      platform_sale_check_state = Number(platform_sale_check_state);
      contract_check_state = Number(contract_check_state);
      send_state = Number(send_state);
      pay_state = Number(pay_state);

      let state = 1;
      return [platform_sale_check_state, contract_check_state, send_state].includes(state) && pay_state === 2

    },
    checkConfirmOrder(item) {
      let {platform_sale_check_state, contract_check_state} = item;
      return [0, -1].includes(Number(contract_check_state)) || [0].includes(Number(platform_sale_check_state))
    },
    showCompanyType(order) {
      try {
        if (this.is_Empty(order)) return "";
        if (this.is_Empty(order.company_source)) return "";
        if (order.company_source !== 'machinery_manufacturers') return "";
        let o = this.dictList.find(el => {
          return el.dict_data_value === order.company_source;
        })
        return o.name;
      } catch (e) {
        return ""
      }

    },
    async getDictDataList() {
      let res = await this.post("dict/getDictDataList", {dict_type_value: "company_source"});
      this.dictList = res.data;
    },
    //担保发货
    guaranteeSend(order_id) {
      this.$confirm("是否确认担保此订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            let param = {
              order_id: order_id
            };

            this.post("orderInterfaces/v1.0/guaranteeOrder", param).then(res => {
              this.$message({
                type: "success",
                message: "担保成功!"
              });
            });
          })
          .catch(() => {
          });
    },
    //获取订单列表
    getOrderList() {
      this.loading = true;
      let param = {
        page: this.page,
        order_no: this.search.order_no,
        company_check_state: "1",
        contract_check_state: "",
        platform_sale_check_state: "0,1",
        send_state: ""
      };
      if (this.tab == 0) {
        param.contract_check_state = "";
        param.platform_sale_check_state = "0,1";
        param.send_state = "";
      } else if (this.tab == 1) {
        param.contract_check_state = "0,-1";
        param.platform_sale_check_state = "0,1";
        param.send_state = "";
      } else if (this.tab == 2) {
        param.contract_check_state = "1";
        param.platform_sale_check_state = "1";
        param.contract_check_state = "1";
        param.send_state = "1";
        param.pay_state = "2";
      }
      this.post("orderInterfaces/v1.0/getSellOrders", param).then(res => {
        this.order_list = res.data;
        this.total = res.total;
        this.loading = false;
      });
    },
    //    驳回订单
    rejectOrder(item) {
      this.order_id = item.order_id;
      this.currentMessage = item.return_to_platform_sale_check_remarks;
      this.rejectShow = true;
    }
  },
  components: {rejectOrder, sendState, payState, assignmentStatus}
};
</script>

<style scoped lang="scss">
.order-table {
  width: 100%;
  margin-top: 20px;

  th {
    font-size: 14px;
  }

  .sep-row {
    height: 20px;
  }

  thead {
    background-color: #F0F6FF;
    font-size: 12px;
    line-height: 18px;

    th {
      padding: 10px;
    }
  }

  .tr-th {
    background-color: #F0F6FF;
    font-size: 12px;
    line-height: 18px;

    td {
      padding: 10px;
      border: 1px solid #eee;
    }
  }

  .tr-bd {
    font-size: 12px;

    td {
      border: 1px solid #eee;
      text-align: center;
      vertical-align: middle;

      .good-item {
        width: 270px;
        padding: 10px;
        display: flex;
        text-align: left;
        line-height: 14px;

        .good-img {
          width: 80px;
          height: 80px;
          display: inline-block;
          margin-right: 10px;
        }
      }

      .btn-item {
        width: 80px;
      }

      .order-price {
        text-align: right;
        padding: 10px 10px 10px 0;
      }
    }

  }

}

</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/index.vue